export enum DeliveryStatusEnum {
  WAITING = "WAITING",
  ONGOING = "ONGOING",
  PARTIALLY_DELIVERED = "PARTIALLY_DELIVERED",
  DELIVERED = "DELIVERED",
  TOTALLY_DELIVERED = "TOTALLY_DELIVERED",
  FAILED = "FAILED",
  BLOCKED = "BLOCKED",
}

export enum ClientDeliveryStatusEnum {
  WAITING = DeliveryStatusEnum.WAITING,
  ONGOING = DeliveryStatusEnum.ONGOING,
  DELIVERED = DeliveryStatusEnum.DELIVERED,
}
